import React, {ReactNode} from 'react';
import clsx from 'clsx';
import {useNavigate} from 'react-router-dom';
import {useOpenModals} from 'context/openModals';
import {usePath} from '../../hooks';
import {SessionStorage} from '@guestapp/core';
import {PATHS} from '../../Routes';
import {PREVIOUS_PAGE_STORAGE_KEY} from 'utils/constants';
import Navbar from 'components/common/Navbar';
import Loading from 'components/common/Loading';
import SubHeaderPanel from '../SubHeaderPanel';
import LanguageSDKSwitcher from '../LanguageSDKSwitcher';
import SubHeader, {SubHeaderProps} from 'components/common/SubHeader';
import {HeightObserverProvider} from 'context/heightObserver';
import {ScrollArea} from '@chekin/guestapp-ui-kit';
import {PageWrapper, PageBanner, Wrapper, BottomStickyPanel} from './styled';

type BannerProps = {
  src: string;
  onClick?: () => void;
};
export type PageProps = SubHeaderProps & {
  children: ReactNode;
  isSubHeaderVisible?: boolean;
  subtitle?: string;
  className?: string;
  isLoading?: boolean;
  mainHeader?: boolean;
  hideSubPanelBackButton?: boolean;
  onBackButtonSubHeaderClick?: () => void;
  headerLogo?: string;
  banner?: BannerProps;
  navBarTitle?: string;
  bottomStickyPanel?: ReactNode;
  subheaderRightAddon?: ReactNode;
};

function Page({
  children = '',
  title = '',
  subtitle,
  isSubHeaderVisible = false,
  className,
  isLoading = false,
  mainHeader,
  isBackButtonDisabled = false,
  hideMenu = false,
  onBackButtonClick,
  hideSubPanelBackButton = false,
  onBackButtonSubHeaderClick,
  subheaderRightAddon,
  headerLogo,
  banner,
  navBarTitle,
  bottomStickyPanel,
}: PageProps) {
  const {checkIfOpenDiscardModalAndRedirect} = useOpenModals();
  const navigate = useNavigate();
  const {getMainPath} = usePath();
  const handleBackButtonClick =
    onBackButtonSubHeaderClick || (() => checkIfOpenDiscardModalAndRedirect('-1'));

  const handleSubHeaderBackButtonClick =
    onBackButtonClick ??
    (() => {
      if (!SessionStorage.get(PREVIOUS_PAGE_STORAGE_KEY)) {
        navigate(getMainPath(PATHS.home));
      } else {
        navigate(-1);
      }
    });

  return (
    <Loading isLoading={isLoading}>
      <PageWrapper className="page">
        <ScrollArea type="always">
          <HeightObserverProvider>
            <Navbar visible={mainHeader} title={navBarTitle} />
            {isSubHeaderVisible && (
              <SubHeader
                title={title}
                isBackButtonDisabled={isBackButtonDisabled}
                hideMenu={hideMenu}
                onBackButtonClick={handleSubHeaderBackButtonClick}
                headerLogo={headerLogo}
                mobileTitle={navBarTitle}
                rightAddon={subheaderRightAddon}
              />
            )}
            {subtitle && (
              <SubHeaderPanel
                title={subtitle}
                onBackClick={handleBackButtonClick}
                hideBackButton={hideSubPanelBackButton}
              />
            )}
            {banner && (
              <PageBanner
                src={banner?.src}
                onClick={() => banner.onClick?.()}
                className="page-banner"
              />
            )}
            <Wrapper className={clsx(className, 'page_content')}>{children}</Wrapper>
            {bottomStickyPanel && (
              <BottomStickyPanel>{bottomStickyPanel}</BottomStickyPanel>
            )}
            <LanguageSDKSwitcher />
          </HeightObserverProvider>
        </ScrollArea>
      </PageWrapper>
    </Loading>
  );
}

export {Page};
